// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1IRz2","noSpots":"styles_noSpots__zaTo2"};